import { render, staticRenderFns } from "./followAddDialog.vue?vue&type=template&id=134b8d57"
import script from "./followAddDialog.vue?vue&type=script&lang=js"
export * from "./followAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports